import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f2bf5394"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validating-panel-placeholder__left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Level Placeholder",
    class: "validating-panel-placeholder__level",
    src: "/img/placeholders/level.svg"
  })
], -1))
const _hoisted_2 = { class: "validating-panel-placeholder__right" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validating-panel-placeholder__footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "placeholder-block" }),
  /*#__PURE__*/_createElementVNode("div", { class: "placeholder-block placeholder-block--important" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentPlaceholdersText = _resolveComponent("ContentPlaceholdersText")!
  const _component_ContentPlaceholders = _resolveComponent("ContentPlaceholders")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createBlock(_component_PxPanel, { class: "validating-panel-placeholder px-panel--mobile-no-side-borders" }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_ContentPlaceholders, {
        class: "validating-panel-placeholder__container",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ContentPlaceholdersText, { lines: 2 }),
            _createVNode(_component_ContentPlaceholdersText, {
              lines: _ctx.isMobile ? 1 : 3
            }, null, 8, ["lines"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ContentPlaceholders, { rounded: "" }, {
        default: _withCtx(() => [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_ContentPlaceholdersText, {
                key: 0,
                lines: 3,
                class: "validating-panel-placeholder__mobile-description"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (!_ctx.isMobile)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _hoisted_3
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}